    // AET Tour Planner State
    // Placeholder bootstrap file.
    // The full implementation will be added incrementally during integration.

    window.AETPlannerState = window.AETPlannerState || {
      VERSION: 1,
      STORAGE_KEY: "aetTourPlanner",

      load() {
        try {
          return JSON.parse(sessionStorage.getItem(this.STORAGE_KEY) || "{}");
        } catch (e) {
          return {};
        }
      },

      save(state) {
        sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(state || {}));
        return state;
      },

      clear() {
        sessionStorage.removeItem(this.STORAGE_KEY);
      }
    };
